/**
 * appointment list mock data
 * http://mockjs.com/
 */
import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'

Mock.mock(/service\/bookings\?[^is_confirmed]/, 'get' + mockSwitch, {
  'code': 0,
  'message': '',
  'data': {
    'time': 'all',
    'is_confirmed': '',
    'bookings|10': [{
      'id|+1': 1,
      'status': /unknown|pending_fulfillment|fulfilled|canceled/,
      'is_confirmed|1-2': false,
      'service': {
        'id': 1,
        'name': /保养维修|车辆检测|钣金喷漆|其它/,
        'logo_url': Mock.Random.image('88x88'),
        'code': 'code'
      },
      'plate_number': '粤B12345',
      'service_consultant': {
        'id': 1,
        'name': '黄某某',
        'mobile_number': '13811111111',
        'avatar': Mock.Random.image('88x88')
      },
      'appointed_time': Mock.Random.datetime('2016-12-12 HH:mm:ss'),
      'canceled_at': Mock.Random.datetime('yyyy-MM-dd HH:mm:ss'),
      'fulfilled_at': Mock.Random.datetime('yyyy-MM-dd HH:mm:ss'),
      'created_at': Mock.Random.datetime('yyyy-MM-dd HH:mm:ss')
    }],
    'count': 10,
    'page': 1,
    'total_count': 40
  }
})

Mock.mock(/service\/bookings\/\d+/, 'get' + mockSwitch, {
  'code': 0,
  'message': '',
  'data': {
    'id': 1,
    // 'status': /unknown|pending_fulfillment|fulfilled|canceled/,
    'status': 'pending_fulfillment',
    'is_confirmed': true,
    'service': {
      'id': 1,
      'name': /保养维修|车辆检测|钣金喷漆|其它/,
      'logo_url': Mock.Random.image('88x88'),
      'code': 'code'
    },
    'remark': /aaaaaa aaaaaaaaaaa aaaaaa aaaaaa aaaaaaa aaaaaaaa|备注备注备注备备注备备注备,备注备备注备备注备备注备备注备备注备备注备备注备备注备备注备备注备备注备。/,
    'plate_number': '粤B12345',
    'mileage': 500,
    'contact_name': '陈一陈',
    'contact_number': '13811111111',
    'service_consultant': {
      'id': 1,
      'name': '黄某某',
      'mobile_number': '13811111111',
      'avatar': Mock.Random.image('88x88')
    },
    'appointed_time': Mock.Random.datetime('2016-12-12 HH:mm:ss'),
    'canceled_at': Mock.Random.datetime('yyyy-MM-dd HH:mm:ss'),
    'fulfilled_at': Mock.Random.datetime('yyyy-MM-dd HH:mm:ss'),
    'created_at': Mock.Random.datetime('yyyy-MM-dd HH:mm:ss')
  }
})
